import { DialogActions } from '@mui/material';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const StyledDialogActions = styled(DialogActions)`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-bottom: 8px;
  margin-right: 14px;
`;
